module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-500-[51]294.9b80173.woff2";